import { useMemo } from 'react';

import { useStaticContext } from '~/utilities/context/static/StaticContext';

export const useAlgoliaAttributesToRetrieve = (
  defaultAttributesToRetrieve: Array<string>,
  extraImageProfiles = ''
) => {
  const {
    configuration: {
      allowedProductTilePrimaryImageTypes,
      allowedProductTileHoverImageTypes,
      allowedProductTileSpecialMaterialHoverImageTypes,
    },
  } = useStaticContext();

  const attributesToRetrieve = useMemo(() => {
    const requireImageProfiles = [
      ...(allowedProductTilePrimaryImageTypes?.split('|') ?? []),
      ...(allowedProductTileHoverImageTypes?.split('|') ?? []),
      ...(allowedProductTileSpecialMaterialHoverImageTypes?.split('|') ?? []),
      ...(extraImageProfiles ? extraImageProfiles.split('|') : []),
    ];

    return defaultAttributesToRetrieve.concat(
      Array.from(new Set(requireImageProfiles)).flatMap(profile => [
        `simplifiedImageJson.${profile}.url`,
        `simplifiedImageJson.${profile}.isAI`,
      ])
    );
  }, [
    defaultAttributesToRetrieve,
    allowedProductTileHoverImageTypes,
    allowedProductTilePrimaryImageTypes,
    allowedProductTileSpecialMaterialHoverImageTypes,
    extraImageProfiles,
  ]);

  return attributesToRetrieve;
};
